export const editorConfig = {
  toolbar: [
    { name: 'editing', items: ['Undo', 'Redo'] },
    {
      name: 'text',
      items: ['Format', 'Bold', 'Italic', 'Underline', 'Strike'],
    },
    { name: 'link', items: ['Link', 'Unlink'] },
    {
      name: 'format',
      items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
    },
    {
      name: 'paragraph',
      items: ['BulletedList', 'NumberedList', 'BidiLtr', 'BidiRtl'],
    },
  ],
  toolbarGroups: [
    { name: 'group1', groups: ['editing'] },
    { name: 'group2', groups: ['text'] },
    { name: 'group3', groups: ['link'] },
    { name: 'group4', groups: ['format'] },
    { name: 'group5', groups: ['paragraph'] },
  ],
};
